import {Component} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {UserI} from '../../interfaces/user.interface';
import {AppService} from 'src/app/services/app.service';

@Component({
  selector: 'app-profile-page',
  templateUrl: './profile-page.component.html',
  styleUrls: ['./profile-page.component.scss']
})
export class ProfilePageComponent {
  private user: UserI;

  public familyNameFormControl: FormControl;

  public givenNameFormControl: FormControl;

  public salutFormControl: FormControl;


  constructor(private app: AppService) {
    this.app.isAuthed((auth: boolean) => {
      if (!auth) {
        this.app.router.navigateByUrl('');
      }
    });

    this.user = this.app.user;

    this.familyNameFormControl = new FormControl(this.user.family_name, [
      Validators.required,
    ]);

    this.givenNameFormControl = new FormControl(this.user.given_name, [
      Validators.required,
    ]);

    this.salutFormControl = new FormControl(this.user.salut, [
      Validators.required,
    ]);
  }

  public onSubmit(): void {
    this.user.family_name = this.familyNameFormControl.value;
    this.familyNameFormControl.updateValueAndValidity();
    this.user.given_name = this.givenNameFormControl.value;
    this.givenNameFormControl.updateValueAndValidity();
    this.user.salut = this.salutFormControl.value;
    this.salutFormControl.updateValueAndValidity();

    if (
      !this.familyNameFormControl.errors &&
      !this.salutFormControl.errors &&
      !this.givenNameFormControl.errors) {
      this.update();
    }
  }

  protected update(): void {
    this.app.dialog.loader({
      title: 'Aktualisiere Profil'
    });
    this.user.name = ([this.user.given_name, this.user.middle_name, this.user.family_name]).join(' ');
    this.app.updateUser(this.user).then(() => {
      this.app.dialog.closeLoader();

      this.app.toast.open('Profil aktualisiert');

    }).catch((e: Error) => {
      console.error(e);
      this.app.toast.open('Unbekannter Fehler', null, {
        panelClass: 'warn'
      });
      this.app.dialog.closeLoader();
    });
  }


}
